/*
 *
 * DisputeDownloadModal
 *
 * @version 1.0.0
 * @author Alessandro Mancuso
 * @since 15-May-2025
 */

import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

// Components
import { DocumentXLS, DocumentCVS } from '@nexidigital/iconlibrary'
import Toggle from 'Hoc/ToggleComponent'
import MerchantModal from '@nexidigital/merchantmodal'

// Texts
import formattedMessage from './languageModule'

// Styles
import './DisputeDownloadModal.scss'

const DisputeDownloadModal = (props) => {
  const [downloadingFormat, setDownloadingFormat] = useState(null)

  useEffect(() => {
    if (!props.downloadLoading && downloadingFormat) {
      setDownloadingFormat(null)
    }
  }, [props.downloadLoading])

  const handleDownload = (type) => {
    setDownloadingFormat(type)
    props.actions.doDownloadDisputeList({
      subStatus: props.dossierSubStatus,
      ...props.filterParams,
      type,
      pageNumber: 1,
      pageSize: props.totalRecords,
      status: props.dossierStatus
    })
  }

  return (
    <Toggle>
      <MerchantModal
        iconName='errorCheck'
        onClose={() => props.actions.doHidePopup()}
        title={formattedMessage.title}
        description={formattedMessage.description}
        primaryButtonLabel={formattedMessage.downloadCSV}
        primaryAction={() => handleDownload('CSV')}
        primaryIcon={<DocumentCVS size='24' type='line' />}
        primaryButtonTertiary
        primaryButtonLoading={props.downloadLoading && downloadingFormat === 'CSV'}
        secondaryButtonLabel={formattedMessage.downloadXLS}
        secondaryAction={() => handleDownload('XLS')}
        secondaryIcon={<DocumentXLS size='24' type='line' />}
        secondaryButtonTertiary
        secondaryButtonLoading={props.downloadLoading && downloadingFormat === 'XLS'}
      />
    </Toggle>
  )
}

DisputeDownloadModal.propTypes = {
  totalRecords: PropTypes.number,
  filterParams: PropTypes.object,
  downloadLoading: PropTypes.bool,
  dossierStatus: PropTypes.string,
  dossierSubStatus: PropTypes.string,
  actions: PropTypes.shape({
    doDownloadDisputeList: PropTypes.func,
    doHidePopup: PropTypes.func
  }).isRequired
}

DisputeDownloadModal.defaultProps = {
  totalRecords: 0,
  filterParams: {},
  downloadLoading: false,
  dossierStatus: '',
  dossierSubStatus: '',
  actions: {}
}

export default DisputeDownloadModal
